import * as React from "react";

// Set defaults for reuse
const DEFAULTS = {
  open: true,
  handleDrawerClose: () => {},
  handleDrawerOpen: () => {},
};
const DrawerContext = React.createContext(DEFAULTS);

const DrawerProvider: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => {
  const [open, setOpen] = React.useState(DEFAULTS.open);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const contextValues = {
    open,
    handleDrawerOpen,
    handleDrawerClose,
  };

  return (
    <DrawerContext.Provider value={contextValues}>
      {children}
    </DrawerContext.Provider>
  );
};

export { DrawerContext };
export default DrawerProvider;
